import { Observable, throttle, addEventListener } from '@datadog/browser-core';
let viewportObservable;
export function initViewportObservable(configuration) {
  if (!viewportObservable) {
    viewportObservable = createViewportObservable(configuration);
  }
  return viewportObservable;
}
export function createViewportObservable(configuration) {
  return new Observable(observable => {
    const {
      throttled: updateDimension
    } = throttle(() => {
      observable.notify(getViewportDimension());
    }, 200);
    return addEventListener(configuration, window, "resize" /* DOM_EVENT.RESIZE */, updateDimension, {
      capture: true,
      passive: true
    }).stop;
  });
}
// excludes the width and height of any rendered classic scrollbar that is fixed to the visual viewport
export function getViewportDimension() {
  const visual = window.visualViewport;
  if (visual) {
    return {
      width: Number(visual.width * visual.scale),
      height: Number(visual.height * visual.scale)
    };
  }
  return {
    width: Number(window.innerWidth || 0),
    height: Number(window.innerHeight || 0)
  };
}
